import { render, staticRenderFns } from "./SidePanel.vue?vue&type=template&id=78811076&scoped=true"
import script from "./SidePanel.vue?vue&type=script&lang=js"
export * from "./SidePanel.vue?vue&type=script&lang=js"
import style0 from "./SidePanel.vue?vue&type=style&index=0&id=78811076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78811076",
  null
  
)

export default component.exports